var map = {
	"./24-7.png": 81643,
	"./24-7_fr.png": 79160,
	"./AA.png": 76039,
	"./AA_fr.png": 41420,
	"./LAF.png": 38624,
	"./LAF_fr.png": 70389,
	"./LAF_uk.png": 37301
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33015;